<template>
  <div class="container pt-3 pb-5">
    <h1 class="my-4">My Wishlist</h1>
    <button @click="goBack" class="btn btn-outline-dark mb-3">
      &#8592; Buy More Products
    </button>
    <div>  
      <div v-if="wishlistItems.length === 0" class="alert alert-info">
        Your wishlist is empty.
      </div>
      <div v-else class="list-group">
        <div
          v-for="item in wishlistItems"
          :key="item._id"
          class="list-group-item d-flex align-items-center justify-content-between"
        >
          <div class="d-flex align-items-center">
            <img
              :src="item.images?.[0] ? `${BASE_IMAGE_PREFIX}/${item.images[0]}` : `${PLACEHOLDER_IMAGE}`"
              class="img-thumbnail me-3"
              alt="Product image"
              style="width: 75px; height: auto"
            />
            <div>
              <h5 class="mb-1">{{ item.title }}</h5>
              <p
                v-if="item.productCategory !== 'stationary'"
                class="mb-1"
              >
                Brand: {{ item.brand }}
              </p>
              <p class="mb-1" v-if="item.variant">
                Price:
                <span v-if="item.variant.salePrice">
                  <span class="text-decoration-line-through text-muted me-1">৳ {{ item.variant.price }}</span>
                  ৳ {{ item.variant.salePrice }}
                </span>
                <span v-else>৳ {{ item.variant.price }}</span>
              </p>
            </div>
          </div>
          <div>
            <button
              class="btn btn-dark btn-sm mx-3"
              @click="addToCart(item)"
            >
              Add to cart
            </button>
            <button
              class="btn btn-danger btn-sm"
              @click="removeFromWishlist(item)"
            >
              Remove
            </button>
          </div>
        </div>
        <div class="d-flex justify-content-end mt-3">
          <button class="btn btn-dark">
            <router-link class="nav-link" to="/cart">
              Go To Cart &#8594;
            </router-link>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { BASE_IMAGE_PREFIX, PLACEHOLDER_IMAGE } from '@/globals';

export default {
  data() {
    return {
      BASE_IMAGE_PREFIX,
      PLACEHOLDER_IMAGE,
    }
  },
  computed: {
    wishlistItems() {
      return this.$store.getters.wishlistItems;
    },
  },
  methods: {
    addToCart(product) {
        const payload = {
          product: {
              _id: product._id,
              title: product.title,
              brand: product.brand,
              productCategory: product.productCategory,
              images: product.images,
              minVariant: product.minVariant
          },
          variant: product.variant || product.minVariant,
          quantity: 1
      }
      this.$store.dispatch("addToCart", payload);
      this.removeFromWishlist(product)
      this.$root.showToast({
        message: "Item added to cart",
        status: "success",
        duration: 3000,
      });
    },
    removeFromWishlist(item) {
      this.$store.dispatch("removeFromWishlist", item);
      this.$root.showToast({
        message: "Item removed from wishlist",
        status: "success",
        duration: 3000,
      });
    },
    goBack() {
      this.$router.go(-1); // Or use this.$router.back();
    },
  },
};
</script>

<style scoped>
.list-group-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.img-thumbnail {
  max-width: 75px; /* Ensure the image is small */
  max-height: 100px; /* Optional: control height */
}
</style>
